<template>
  <main-layout>
    <div>
      <priority-dialog
        v-model="isPriorityDialogOpened"
        :priority="selectedPriority"
        @save="stateSave"
        @close="resetSelectedPriority"/>
      <delete-priority-dialog
        v-model="isDeletePriorityDialogOpened"
        :priority="selectedPriority"
        @delete="stateDelete"
        @close="resetSelectedPriority"/>
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Priorités</span>
        <v-spacer></v-spacer>
        <v-btn dark color="primary" elevation="0" @click="isPriorityDialogOpened = true">
          <v-icon left>add</v-icon>
          Nouvelle priorité
        </v-btn>
      </v-row>
      <div class="page-main-content">
        <v-simple-table class="pt-5">
          <thead>
            <tr>
              <th class="text-left">Nom</th>
              <th/>
            </tr>
          </thead>
          <tbody>
            <tr v-for="priority in makerPriorities" :key="priority.name">
              <td>{{ priority.name }}</td>
              <td class="text-right admin-list-actions">
                <v-btn icon small @click="savePriority(priority)"><v-icon>edit</v-icon></v-btn>
                <!-- <v-btn icon small>
                  <v-icon color="red" @click="deletePriority(priority)">delete</v-icon>
                </v-btn> -->
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
  </main-layout>
</template>

<script>
import { mapState } from 'vuex';
import MainLayout from '@/views/settings/MainLayout.vue';
import PriorityDialog from '@/components/Priority/PriorityDialog.vue';
import DeletePriorityDialog from '@/components/Priority/DeletePriorityDialog.vue';

export default {
  name: `SettingsPriorities`,
  data: () => ({
    isPriorityDialogOpened: false,
    isDeletePriorityDialogOpened: false,
    selectedPriority: {},
  }),
  computed: {
    ...mapState(`model/priority`, [
      `makerPriorities`,
    ]),
  },
  methods: {
    savePriority(priority) {
      this.selectedPriority = priority;
      this.isPriorityDialogOpened = true;
    },
    deletePriority(priority) {
      this.selectedPriority = priority;
      this.isDeletePriorityDialogOpened = true;
    },
    async fetchPriorities() {
      await this.$store.dispatch(`model/client/fetchCompany`);
      this.$store.dispatch(`model/priority/fetchMakerPriorities`);
    },
    async stateSave() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: this.selectedPriority && this.selectedPriority.id ? `Priorité modifiée avec succès` : `Priorité créée avec succès`,
      });
      this.selectedPriority = {};
    },
    async stateDelete() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Priorité supprimée avec succès`,
      });
      this.selectedStatus = {};
    },
    resetSelectedPriority() {
      this.selectedPriority = {};
    },
  },
  mounted() {
    this.fetchPriorities();
  },
  components: {
    MainLayout,
    PriorityDialog,
    DeletePriorityDialog,
  },
};
</script>

<style lang="scss">
  .sheet-item {
    border: 2px solid rgba(119, 119, 119, 0.527) !important;
    border-radius: 4px;
  }
  .width-raw-priority {
    max-width: 800px !important;
  }
</style>
